/**
 * ALPHA NUTRITION - FUTURISTIC THEME ENGINE
 * Infinite Scroll, Category Filter, Smooth Anchor Scrolling, Interactive Nutrition Modal Zoom, Cart Drawer with Discount Tracking & Live Shopify Cart Session Integration
 */

document.addEventListener('DOMContentLoaded', () => {
  initInfiniteScroll();
  initCategoryFilters();
  initSmoothScroll();
  initNutritionModalZoom();
  initCartDrawer();
  initSearch();
  initCardClickNavigation();
  initHeroPaymentBadge();
});

/**
 * Hero MercadoPago Badge Rotation
 */
function initHeroPaymentBadge() {
  const badge = document.getElementById('hero-mp-badge');
  if (!badge) return;
  const slides = badge.querySelectorAll('.hero-mp-slide');
  if (slides.length <= 1) return;
  let current = 0;
  setInterval(() => {
    slides[current].classList.remove('active');
    current = (current + 1) % slides.length;
    slides[current].classList.add('active');
  }, 3000);
}

/**
 * Entire Product Card Click Navigation Handler
 */
function initCardClickNavigation() {
  document.addEventListener('click', (e) => {
    const card = e.target.closest('.store-product-card');
    if (!card) return;

    // If click was inside action buttons or zoom modal badge, let specific handlers manage it
    if (e.target.closest('.btn-add-cart') || 
        e.target.closest('.btn-direct-checkout') || 
        e.target.closest('.btn-nutrition-modal') ||
        e.target.closest('a')) {
      return;
    }

    const targetUrl = card.dataset.productUrl || card.querySelector('a[href]')?.getAttribute('href');
    if (targetUrl && targetUrl !== '#') {
      window.location.href = targetUrl;
    }
  });
}

window.AlphaStore = {
  cart: [],
  allProducts: [],
  filteredProducts: [],
  currentPage: 1,
  pageSize: 16,
  isLoading: false,
  activeCategory: 'all'
};

/**
 * Bulletproof Price Numeric Parser (handles $ 1.017, $ 1.017,00, $ 1017.00 & Shopify cents without adding 2 zeros)
 */
function parseCartPrice(str) {
  if (!str) return 0;
  let s = str.toString().trim();
  
  // Strip trailing cents (,00 or .00) if formatted with currency sign
  if (s.includes('$')) {
    s = s.replace(/[,.]00$/, '');
    s = s.replace(/[^\d]/g, '');
    return parseInt(s, 10) || 0;
  }

  let num = parseInt(s.replace(/[^\d]/g, ''), 10) || 0;
  // If raw number comes from Shopify cents (e.g. 101700 for $ 1.017), divide by 100
  if (num >= 10000 && num % 100 === 0) {
    num = Math.floor(num / 100);
  }
  return num;
}

/**
 * Silky Smooth Anchor & Nav Link Scroll Handler
 */
function initSmoothScroll() {
  document.querySelectorAll('a[href^="#"], .smooth-scroll-btn').forEach(anchor => {
    anchor.addEventListener('click', function (e) {
      const targetId = this.getAttribute('href');
      if (!targetId || targetId === '#') return;

      const targetElem = document.querySelector(targetId);
      if (targetElem) {
        e.preventDefault();
        
        const catTarget = this.dataset.categoryTarget;
        if (catTarget) {
          const matchingFilterBtn = document.querySelector(`.filter-btn[data-category="${catTarget}"]`);
          if (matchingFilterBtn) {
            matchingFilterBtn.click();
          }
        }

        targetElem.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
      }
    });
  });
}

/**
 * Category Filter Handler
 */
function initCategoryFilters() {
  const filterBtns = document.querySelectorAll('.filter-btn');
  filterBtns.forEach(btn => {
    btn.addEventListener('click', () => {
      filterBtns.forEach(b => b.classList.remove('active'));
      btn.classList.add('active');
      const cat = btn.dataset.category || 'all';
      window.AlphaStore.activeCategory = cat;
      filterProducts(cat);
    });
  });
}

function filterProducts(category) {
  const grid = document.getElementById('product-grid');
  if (!grid) return;

  grid.style.opacity = '0';
  grid.style.transform = 'translateY(10px)';

  setTimeout(() => {
    const cards = grid.querySelectorAll('.store-product-card');
    cards.forEach(card => {
      const cardCat = card.dataset.category || '';
      const cardTitle = card.dataset.title || '';
      
      if (category === 'all' || cardCat.includes(category) || cardTitle.toLowerCase().includes(category)) {
        card.style.display = 'flex';
      } else {
        card.style.display = 'none';
      }
    });
    grid.style.opacity = '1';
    grid.style.transform = 'translateY(0)';
  }, 200);
}

/**
 * Infinite Scroll Loader Engine
 */
function initInfiniteScroll() {
  const loader = document.getElementById('scroll-loader');
  if (!loader) return;

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting && !window.AlphaStore.isLoading) {
        loadMoreProducts();
      }
    });
  }, { rootMargin: '300px' });

  observer.observe(loader);
}

function loadMoreProducts() {
  window.AlphaStore.isLoading = true;
  const loader = document.getElementById('scroll-loader');
  if (loader) loader.style.opacity = '1';

  setTimeout(() => {
    const hiddenCards = document.querySelectorAll('.store-product-card:not(.spawned)');
    let revealed = 0;
    hiddenCards.forEach((card, idx) => {
      if (revealed < window.AlphaStore.pageSize) {
        setTimeout(() => card.classList.add('spawned'), idx * 30);
        revealed++;
      }
    });

    if (document.querySelectorAll('.store-product-card:not(.spawned)').length === 0) {
      if (loader) loader.style.display = 'none';
    }

    window.AlphaStore.isLoading = false;
  }, 300);
}

/**
 * Interactive Nutrition Modal Zoom & Drag Engine
 */
function initNutritionModalZoom() {
  const overlay = document.getElementById('nutrition-modal');
  const modalImg = document.getElementById('modal-nutrition-img');
  const modalTitle = document.getElementById('modal-nutrition-title');
  const viewport = document.getElementById('modal-viewport');
  const closeBtn = document.getElementById('modal-close');
  
  const zoomInBtn = document.getElementById('zoom-in');
  const zoomOutBtn = document.getElementById('zoom-out');
  const zoomResetBtn = document.getElementById('zoom-reset');
  const zoomLevelLabel = document.getElementById('zoom-level');

  if (!overlay) return;

  let zoomScale = 1;
  let translateX = 0;
  let translateY = 0;
  let isDragging = false;
  let startX = 0;
  let startY = 0;

  function updateTransform() {
    if (modalImg) {
      modalImg.style.transform = `translate(${translateX}px, ${translateY}px) scale(${zoomScale})`;
    }
    if (zoomLevelLabel) {
      zoomLevelLabel.textContent = `${Math.round(zoomScale * 100)}%`;
    }
  }

  function resetZoom() {
    zoomScale = 1;
    translateX = 0;
    translateY = 0;
    updateTransform();
  }

  // Open Modal Delegate
  document.addEventListener('click', (e) => {
    const trigger = e.target.closest('.btn-nutrition-modal');
    if (trigger) {
      e.preventDefault();
      e.stopPropagation();
      const imgUrl = trigger.dataset.nutritionImg;
      const title = trigger.dataset.productTitle || 'Información Nutricional';

      if (modalImg) modalImg.src = imgUrl;
      if (modalTitle) modalTitle.textContent = title;

      const modalCartBtn = document.getElementById('modal-btn-cart');
      const modalCheckoutBtn = document.getElementById('modal-btn-checkout');
      if (modalCartBtn) {
        modalCartBtn.dataset.title = title;
        modalCartBtn.dataset.img = imgUrl;
      }
      if (modalCheckoutBtn) {
        modalCheckoutBtn.dataset.title = title;
        modalCheckoutBtn.dataset.img = imgUrl;
      }

      resetZoom();
      overlay.classList.add('active');
    }
  });

  if (closeBtn) {
    closeBtn.addEventListener('click', () => overlay.classList.remove('active'));
  }

  overlay.addEventListener('click', (e) => {
    if (e.target === overlay) overlay.classList.remove('active');
  });

  // Zoom Controls
  if (zoomInBtn) {
    zoomInBtn.addEventListener('click', () => {
      zoomScale = Math.min(3.5, zoomScale + 0.4);
      updateTransform();
    });
  }

  if (zoomOutBtn) {
    zoomOutBtn.addEventListener('click', () => {
      zoomScale = Math.max(1, zoomScale - 0.4);
      if (zoomScale === 1) { translateX = 0; translateY = 0; }
      updateTransform();
    });
  }

  if (zoomResetBtn) {
    zoomResetBtn.addEventListener('click', resetZoom);
  }

  // Scroll Wheel Zoom
  if (viewport) {
    viewport.addEventListener('wheel', (e) => {
      e.preventDefault();
      if (e.deltaY < 0) {
        zoomScale = Math.min(3.5, zoomScale + 0.25);
      } else {
        zoomScale = Math.max(1, zoomScale - 0.25);
        if (zoomScale === 1) { translateX = 0; translateY = 0; }
      }
      updateTransform();
    });

    // Double Click Toggle 2x Zoom
    viewport.addEventListener('dblclick', () => {
      if (zoomScale > 1) {
        resetZoom();
      } else {
        zoomScale = 2;
        updateTransform();
      }
    });

    // Mouse Drag Pan
    viewport.addEventListener('mousedown', (e) => {
      if (zoomScale > 1) {
        isDragging = true;
        startX = e.clientX - translateX;
        startY = e.clientY - translateY;
      }
    });

    window.addEventListener('mousemove', (e) => {
      if (isDragging && zoomScale > 1) {
        translateX = e.clientX - startX;
        translateY = e.clientY - startY;
        updateTransform();
      }
    });

    window.addEventListener('mouseup', () => {
      isDragging = false;
    });
  }
}

/**
 * Interactive Cart Drawer Logic with Live Shopify Session Integration & Click-Outside Close
 */
function initCartDrawer() {
  const drawer = document.getElementById('cart-drawer');
  const openBtns = document.querySelectorAll('.open-cart-btn');
  const closeBtn = document.getElementById('close-cart-btn');

  openBtns.forEach(b => b.addEventListener('click', (e) => {
    e.preventDefault();
    if (drawer) drawer.classList.add('active');
  }));

  if (closeBtn) {
    closeBtn.addEventListener('click', () => drawer.classList.remove('active'));
  }

  // Click outside cart drawer to close
  document.addEventListener('click', (e) => {
    if (drawer && drawer.classList.contains('active')) {
      if (!drawer.contains(e.target) && 
          !e.target.closest('.open-cart-btn') && 
          !e.target.closest('.btn-add-cart') &&
          !e.target.closest('.btn-direct-checkout')) {
        drawer.classList.remove('active');
      }
    }
  });

  // Checkout Button - Sync cart with Shopify then redirect
  document.addEventListener('click', async (e) => {
    const checkoutBtn = e.target.closest('.btn-checkout');
    if (checkoutBtn) {
      e.preventDefault();
      e.stopPropagation();

      if (!window.AlphaStore.cart || window.AlphaStore.cart.length === 0) {
        return;
      }

      checkoutBtn.disabled = true;
      checkoutBtn.textContent = 'PROCESANDO...';

      try {
        await fetch('/cart/clear.js', { method: 'POST' });

        const itemsToAdd = [];
        for (const item of window.AlphaStore.cart) {
          const vid = parseInt(item.variantId, 10);
          if (vid && vid > 0) {
            itemsToAdd.push({ id: vid, quantity: item.qty || 1 });
          }
        }

        if (itemsToAdd.length === 0) {
          checkoutBtn.disabled = false;
          checkoutBtn.textContent = 'FINALIZAR COMPRA ➔';
          return;
        }

        const addRes = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: itemsToAdd })
        });

        if (addRes.ok) {
          window.location.href = '/checkout';
          return;
        }

        let addedAny = false;
        for (const item of itemsToAdd) {
          try {
            const res = await fetch('/cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ items: [item] })
            });
            if (res.ok) addedAny = true;
          } catch (err) { console.warn('Error adding item:', item.id, err); }
        }

        if (addedAny) {
          window.location.href = '/checkout';
          return;
        }

        checkoutBtn.disabled = false;
        checkoutBtn.textContent = 'FINALIZAR COMPRA ➔';
      } catch (err) {
        console.error('Checkout sync error:', err);
        checkoutBtn.disabled = false;
        checkoutBtn.textContent = 'FINALIZAR COMPRA ➔';
      }
    }
  });

  // Add To Cart Handler
  document.addEventListener('click', (e) => {
    const addBtn = e.target.closest('.btn-add-cart');
    if (addBtn) {
      e.preventDefault();
      e.stopPropagation();
      const variantId = addBtn.dataset.variantId || '';
      const title = addBtn.dataset.title;
      const price = addBtn.dataset.price;
      const compare = addBtn.dataset.compare || '';
      const badge = addBtn.dataset.badge || '';
      const img = addBtn.dataset.img;

      let foundProd = null;
      if (window.ALL_PRODUCTS && Array.isArray(window.ALL_PRODUCTS)) {
        foundProd = window.ALL_PRODUCTS.find(p => p.title === title);
      }

      const finalPrice = price || (foundProd ? foundProd.price : '');
      const finalCompare = compare || (foundProd ? foundProd.compare_price : '');
      const finalBadge = badge || (foundProd ? foundProd.discount_badge : '');

      addToCart({
        variantId,
        title,
        price: finalPrice,
        compare: finalCompare,
        badge: finalBadge,
        img
      });

      if (drawer) drawer.classList.add('active');
    }
  });

  // Direct Buy / Checkout Handler
  document.addEventListener('click', async (e) => {
    const directBtn = e.target.closest('.btn-direct-checkout');
    if (directBtn) {
      e.preventDefault();
      e.stopPropagation();
      const variantId = directBtn.dataset.variantId || '';
      const title = directBtn.dataset.title;
      const price = directBtn.dataset.price;
      const compare = directBtn.dataset.compare || '';
      const badge = directBtn.dataset.badge || '';
      const img = directBtn.dataset.img;

      let foundProd = null;
      if (window.ALL_PRODUCTS && Array.isArray(window.ALL_PRODUCTS)) {
        foundProd = window.ALL_PRODUCTS.find(p => p.title === title);
      }

      const finalPrice = price || (foundProd ? foundProd.price : '');
      const finalCompare = compare || (foundProd ? foundProd.compare_price : '');
      const finalBadge = badge || (foundProd ? foundProd.discount_badge : '');

      addToCart({
        variantId,
        title,
        price: finalPrice,
        compare: finalCompare,
        badge: finalBadge,
        img
      });

      // Immediate Checkout - sync with Shopify first
      const vid = parseInt(variantId, 10);
      if (vid && vid > 0) {
        try {
          await fetch('/cart/clear.js', { method: 'POST' });
          const res = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items: [{ id: vid, quantity: 1 }] })
          });
          if (res.ok) {
            window.location.href = '/checkout';
            return;
          }
        } catch (err) {
          console.warn('Direct checkout error:', err);
        }
        window.location.href = `/cart/${variantId}:1`;
      } else {
        window.location.href = '/checkout';
      }
    }
  });
}

function addToCart(item) {
  const existing = window.AlphaStore.cart.find(i => i.title === item.title);
  if (existing) {
    existing.qty++;
  } else {
    window.AlphaStore.cart.push({ ...item, qty: 1 });
  }

  // Synchronize with Shopify Backend Session (/cart/add.js)
  if (item.variantId && typeof fetch !== 'undefined') {
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        items: [{
          id: parseInt(item.variantId, 10),
          quantity: 1
        }]
      })
    }).catch(err => console.log('Shopify session sync info:', err));
  }

  updateCartUI();
}

function updateItemQty(index, delta) {
  if (window.AlphaStore.cart[index]) {
    window.AlphaStore.cart[index].qty += delta;
    if (window.AlphaStore.cart[index].qty <= 0) {
      window.AlphaStore.cart.splice(index, 1);
    }
    updateCartUI();
  }
}

function removeCartItem(index) {
  if (window.AlphaStore.cart[index]) {
    window.AlphaStore.cart.splice(index, 1);
    updateCartUI();
  }
}

function updateCartUI() {
  const badge = document.querySelector('.cart-badge');
  const totalCount = window.AlphaStore.cart.reduce((sum, i) => sum + i.qty, 0);
  if (badge) {
    badge.textContent = totalCount;
    if (totalCount > 0) {
      badge.style.display = 'flex';
      badge.classList.remove('cart-badge-pulse');
      void badge.offsetWidth;
      badge.classList.add('cart-badge-pulse');
    } else {
      badge.style.display = 'none';
    }
  }

  const itemsList = document.getElementById('cart-items-list');
  const cartFooter = document.getElementById('cart-drawer-footer');
  const subtotalElem = document.getElementById('cart-subtotal-val');

  if (!itemsList) return;

  if (window.AlphaStore.cart.length === 0) {
    itemsList.innerHTML = `
      <div style="text-align: center; padding: 4rem 1rem;">
        <div style="font-size: 2.5rem; margin-bottom: 1rem;">🛒</div>
        <p style="color: var(--text-muted); font-size: 0.95rem; font-weight: 600;">Tu carrito está vacío.</p>
      </div>
    `;
    if (cartFooter) cartFooter.style.display = 'none';
    if (subtotalElem) subtotalElem.textContent = '$ 0';
    return;
  }

  // Show footer when items exist
  if (cartFooter) cartFooter.style.display = 'block';

  let html = '';
  let subtotal = 0;
  let totalSavings = 0;

  window.AlphaStore.cart.forEach((item, idx) => {
    const numPrice = parseCartPrice(item.price);
    const numCompare = parseCartPrice(item.compare);

    const itemTotal = numPrice * item.qty;
    subtotal += itemTotal;

    let itemPricesHtml = `<span style="color:var(--accent-success); font-size:0.95rem; font-weight:800;">$ ${itemTotal.toLocaleString('es-UY')}</span>`;

    if (numCompare > numPrice) {
      const compareTotal = numCompare * item.qty;
      totalSavings += (compareTotal - itemTotal);
      itemPricesHtml = `
        <span style="color:var(--accent-success); font-size:0.95rem; font-weight:800;">$ ${itemTotal.toLocaleString('es-UY')}</span>
        <span style="font-size:0.82rem; color:var(--text-muted); text-decoration:line-through; margin-left:0.5rem; font-weight:500;">$ ${compareTotal.toLocaleString('es-UY')}</span>
        <span class="discount-pill" style="font-size:0.68rem; margin-left:0.4rem;">${item.badge || 'OFERTA'}</span>
      `;
    }

    html += `
      <div style="display:flex; gap:0.85rem; align-items:center; margin-bottom:1rem; padding-bottom:1rem; border-bottom:1px solid rgba(255,255,255,0.08);">
        <img src="${item.img}" style="width:55px; height:55px; object-fit:contain; background:#fff; border-radius:8px; padding:4px; flex-shrink:0;">
        
        <div style="flex-grow:1;">
          <h4 style="font-size:0.88rem; font-weight:700; color:#fff; line-height:1.2; margin-bottom:0.35rem;">${item.title}</h4>
          
          <div style="display:flex; align-items:baseline; margin-bottom:0.45rem; flex-wrap:wrap;">
            ${itemPricesHtml}
          </div>
          
          <!-- Quantity Controls & Delete Button -->
          <div style="display:flex; align-items:center; gap:0.6rem;">
            <div style="display:flex; align-items:center; background:var(--bg-card); border:1px solid var(--border-light); border-radius:6px; overflow:hidden;">
              <button type="button" class="cart-qty-btn" data-action="decrease" data-index="${idx}" style="padding:0.25rem 0.65rem; color:#fff; font-weight:800; font-size:0.9rem; cursor:pointer; background:none; border:none;" title="Reducir cantidad">-</button>
              <span style="padding:0.25rem 0.75rem; color:#fff; font-weight:800; font-size:0.85rem; background:rgba(255,255,255,0.05);">${item.qty}</span>
              <button type="button" class="cart-qty-btn" data-action="increase" data-index="${idx}" style="padding:0.25rem 0.65rem; color:#fff; font-weight:800; font-size:0.9rem; cursor:pointer; background:none; border:none;" title="Aumentar cantidad">+</button>
            </div>
            
            <button type="button" class="cart-remove-btn" data-index="${idx}" style="color:#ef4444; font-size:0.85rem; padding:0.25rem 0.5rem; background:rgba(239,68,68,0.1); border:1px solid rgba(239,68,68,0.2); border-radius:6px; cursor:pointer; font-weight:600;" title="Eliminar producto">
              🗑️ Quitar
            </button>
          </div>
        </div>
      </div>
    `;
  });

  if (totalSavings > 0) {
    html += `
      <div style="background:rgba(239,68,68,0.1); border:1px solid rgba(239,68,68,0.2); border-radius:8px; padding:0.6rem 0.9rem; text-align:center; color:#f87171; font-size:0.82rem; font-weight:700; margin-top:1rem;">
        🎉 ¡Estás ahorrando $ ${totalSavings.toLocaleString('es-UY')} en este pedido!
      </div>
    `;
  }

  itemsList.innerHTML = html;
  if (subtotalElem) subtotalElem.textContent = '$ ' + subtotal.toLocaleString('es-UY');
}

// Event delegation for cart quantity buttons (CSP-safe, no inline onclick)
document.addEventListener('click', (e) => {
  const qtyBtn = e.target.closest('.cart-qty-btn');
  if (qtyBtn) {
    e.preventDefault();
    e.stopPropagation();
    const idx = parseInt(qtyBtn.dataset.index, 10);
    const action = qtyBtn.dataset.action;
    if (action === 'decrease') {
      updateItemQty(idx, -1);
    } else if (action === 'increase') {
      updateItemQty(idx, 1);
    }
    return;
  }

  const removeBtn = e.target.closest('.cart-remove-btn');
  if (removeBtn) {
    e.preventDefault();
    e.stopPropagation();
    const idx = parseInt(removeBtn.dataset.index, 10);
    removeCartItem(idx);
  }
});

/**
 * Search functionality
 */
function initSearch() {
  const input = document.getElementById('catalog-search');
  if (!input) return;

  input.addEventListener('input', (e) => {
    const val = e.target.value.toLowerCase().trim();
    filterProducts(val);
  });
}
